import React, { useState } from "react";
import axios from "axios";
import { Modal, Col } from "reactstrap";

const NewSimpleUserModal = ({ onUserCreated }) => {
    const [open, setOpen] = useState(false);

    const [form, setForm] = useState({
        user_NAME: "",
        user_SURNAME: "",
        user_PHONE: "",
        user_EMAIL: "",
        user_PWD: ""
    });

    const toggle = () => setOpen(!open);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        try {
            await axios.post(
                "/api/user/createSimpleUser",
                form,
                { withCredentials: true }
            );

            toggle();
            onUserCreated();
        } catch (err) {
            console.error(err.response?.data || err);
            alert("Erreur création utilisateur");
        }
    };

    return (
        <>
            <button
                title="Ajouter un nouveau compte créateur"
                className="btn btn-outline-primary" onClick={toggle}>
                <i className="mdi mdi-account-plus fs-4 py-0 align-middle"></i> Nouvel utilisateur
            </button>

            <Modal isOpen={open} toggle={toggle}>
                <div className="modal-header">
                    <h5 className="modal-title">Nouvel utilisateur</h5>
                    <button className="close" onClick={toggle}>
                        &times;
                    </button>
                </div>

                <div className="modal-body">
                    {[
                        { label: "Nom", name: "user_SURNAME" },
                        { label: "Prénom", name: "user_NAME" },
                        { label: "Téléphone", name: "user_PHONE" },
                        { label: "Email", name: "user_EMAIL", type: "email" },
                        { label: "Mot de passe", name: "user_PWD", type: "password" }
                    ].map(({ label, name, type }) => (
                        <Col md={12} key={name}>
                            <div className="form-floating mb-3">
                                <input
                                    type={type || "text"}
                                    className="form-control"
                                    name={name}
                                    value={form[name]}
                                    onChange={handleChange}
                                />
                                <label>{label}</label>
                            </div>
                        </Col>
                    ))}
                </div>

                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={toggle}>
                        Annuler
                    </button>
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        Créer
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default NewSimpleUserModal;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license